import React from 'react';
import Button from '../button/Button';
import { ButtonClass } from '../enums/ButtonClass';

interface StatusMessageProps {
    title: string;
    message: string;
    buttonContent: string;
    onAction: () => void;
}

const StatusMessage = ({ title, message, buttonContent, onAction }: StatusMessageProps) => (
    <div className="pds-u-padding-top-40 pds-u-padding-bottom-40">
        <h2>{title}</h2>
        <div className="pds-u-padding-bottom-24">{message}</div>
        <Button mainButtonClass={ButtonClass.PRIMARY} onClick={onAction}
            buttonContent={buttonContent} />
    </div>
);

export default StatusMessage;
